/**
 * Class representing the Tabs component.
 * @extends HTMLElement
 */
class Tabs extends HTMLElement {
  constructor() {
    super();

    this.tabsButton = this.querySelectorAll('[data-tab]');
    this.tabContents = this.querySelectorAll('[data-tab-content]');

    if (this.tabsButton.length && this.tabContents.length) {
      this.initTabs();
    }
  }

  /**
   * Initialize tabs by adding click event listeners to tab buttons.
   */
  initTabs() {
    this.tabsButton.forEach((tabButton) => {
      tabButton.addEventListener('click', () => this.onTabClick(tabButton));
    });
  }

  /**
   * Handle the tab click event.
   * @param {HTMLElement} tab - The clicked tab button.
   */
  onTabClick(tab) {
    if (!tab) return;

    // Get the target tab and its tier from the clicked tab button.
    const tabTarget = tab.getAttribute('data-tab');
    const tabTier = tab.getAttribute('data-tier');

    if (!tabTarget || !tabTier) return;

    // Filter buttons and contents of the same tier.
    const sameTierTabs = Array.from(this.tabsButton).filter(
      (tabButton) => tabButton.getAttribute('data-tier') === tabTier
    );
    const sameTierContents = Array.from(this.tabContents).filter(
      (tabContent) => tabContent.getAttribute('data-tier') === tabTier
    );

    // Update the active state of the same tier tabs.
    sameTierTabs.forEach((tabButton) => {
      const currentTabTarget = tabButton.getAttribute('data-tab');

      if (currentTabTarget !== tabTarget) {
        tabButton.classList.remove('is-active');
      } else {
        tabButton.classList.add('is-active');
      }
    });

    // Update the active state of the same tier contents.
    sameTierContents.forEach((tabContent) => {
      const currentContentTarget = tabContent.getAttribute('data-tab-content');

      if (currentContentTarget !== tabTarget) {
        tabContent.classList.remove('is-active');
      } else {
        tabContent.classList.add('is-active');

        // Find and activate the first tab and its content in the next tier.
        const firstContentTabs = tabContent.querySelectorAll('[data-tab]');
        const firstTabContents = tabContent.querySelectorAll(`[data-tab-content]`);

        let tabButtonContent;

        if (firstContentTabs && firstTabContents) {
          firstContentTabs.forEach((firstContentTab, i) => {
            if (i === 0) {
              firstContentTab.classList.add('is-active');
              tabButtonContent = firstContentTab.getAttribute('data-tab');
            } else {
              firstContentTab.classList.remove('is-active');
            }
          });

          firstTabContents.forEach((firstTabContent) => {
            const firstTabContentTarget = firstTabContent.getAttribute('data-tab-content');

            if (firstTabContentTarget === tabButtonContent) {
              firstTabContent.classList.add('is-active');
            } else {
              firstTabContent.classList.remove('is-active');
            }
          });
        }
      }
    });
  }
}

if (!customElements.get('tabs-section')) {
  customElements.define('tabs-section', Tabs);
}
